export default __webpack_public_path__ + "static/thumbnail1-47a700a87c0ca7f379fe2a99d6c25b06.jpg";